<template>
    <v-dialog v-model="dialog" persistent max-width="400px">
        <v-card class="pa-2">
            <v-card-title>
                <h2>Atención</h2>
            </v-card-title>
            <v-card-text class="px-0">
                <v-container fluid>
                    <v-row>
                        <p v-if="item.status" class="pb-0 mx-auto mb-0">
                            ¿Realmente desea deshabilitar la cuenta?
                        </p>
                        <p v-else class="pb-0 mx-auto mb-0">
                            ¿Realmente desea habilitar la cuenta?
                        </p>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :loading="loading" @click="status" text color="error">Aceptar</v-btn>
                <v-btn :disabled="loading" type="button" :color="color" @click="$parent.status_dialog = false" text>Cancelar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>

import iziToast from 'izitoast'

export default {
    props:['dialog', 'item', 'status_url'],
    data: () => ({
        color:"#000",
        loading:false,
    }),

    methods:{
        status:function(){
            this.loading = true
            let data = new Object()
            data.id = this.item.id

            axios.post(this.status_url, data).then(response => {
                this.loading = false
                if(response.data.success){
                    this.$parent.status_dialog = false

                    let status = this.item.status ? 'deshabilitado' : 'habilitado'

                    iziToast.success({
                        title:"Correcto",
                        message:"Usuario "+ status + " correctamente",
                        position:"topRight"
                    })
                }

                this.$parent.getData()

            }).catch(error => {
                this.$parent.status_dialog = false
                this.loading = false
                iziToast.error({
                    title:"Error",
                    message:"Ha ocurrido un error en la comunicación con el servidor",
                    position:"topRight"
                })
            })
        }
    }
}
</script>
